// extracted by mini-css-extract-plugin
module.exports = {"card":"ModulesCard_card__3wstO","img":"ModulesCard_img__3sIkI","title":"ModulesCard_title__1iiDJ","text":"ModulesCard_text__2L3st"};